import { render } from "./DebitCard.vue?vue&type=template&id=8dc4b772&ts=true"
import script from "./DebitCard.vue?vue&type=script&lang=ts"
export * from "./DebitCard.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__